import { ProcessForm } from "./_ProcessForm";

export function ProcessEdit() {
  return <ProcessForm action="edit" />;
}

export default ProcessEdit;
